<template>
  <div id="voting">
    <div class="voting-questions" v-if="state==='vote'">
      <h2>{{ title }}</h2>
      <form>
        <div class="voting-questions-item" v-for="v in variants" v-bind:key="_q_ + v.id" v-on:click="vote(v)">
          <p><input class="voting-questions-item-radio" type="radio" :value="v.id">{{ v.title }}</p>
          <p v-if="v.subtitle">{{ v.subtitle }}</p>
        </div>
      </form>
    </div>
    <div class="voting-results" v-if="state==='result'">
      <h2>{{ title }}</h2>
      <div class="voting-results-item" v-bind:class="{ 'voting-result-item-selected': v.selected }" v-for="v in variants" v-bind:key="_q_ + v.id">
        <div class="voting-results-item-text">
          <span class="voting-results-item-title">{{ v.title }}</span><span class="voting-result-item-percent"> — {{ Math.round(v.count/answersCount*100) }}%</span>
        </div>
        <div style="width: 100%;" class="voting-result-bar-background">
          <div :style="'width: ' + v.count/topAnswerCount*100 + '%; height: 100%'" class="voting-result-bar" v-bind:class="{ 'voting-result-bar-selected': v.selected }"></div>
        </div>
      </div>
      <div class="voting-results-overall-text">
        <span class="voting-results-item-title">Всего проголосовало </span><span class="voting-result-item-percent"> {{ answersCount }} чел.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { asyncGetQuestions, asyncPushResult } from './backend.js'

export default {
  name: 'App',
  components: {
  },
  data: function () {
    return {
      state: 'nop',
      id: 0,
      title: '1',
      subtitle: '',
      expires: '',
      opened: false,
      variants: []
    }
  },
  methods: {
    vote: function (e) {
      asyncPushResult(this.id, e.id).then(r => {
        this.update(r)
        this.state = 'result'
      })
    },
    update: function (r) {
      this.id = r.id
      this.title = r.title
      this.subtitle = r.subtitle
      this.expires = r.expires
      this.opened = r.opened
      this.variants = r.variants
    }
  },
  computed: {
    topAnswerCount: function () {
      const max = Math.max(...this.variants.map(i => i.count))
      return max > 0 ? max : 1
    },
    answersCount: function () {
      return this.variants.reduce((a, b) => a + b.count, 0)
    }
  },
  created: function () {
    asyncGetQuestions(1).then(r => {
      this.update(r)
      this.state = r.opened ? 'vote' : 'result'
    })
  }
}

</script>

<style>
#voting {
}
.voting-questions {
}
.voting-questions-item {}
.voting-questions-item-radio {
  margin-right: 10px;
}
.voting-results {}
.voting-results-item {
  padding-bottom: 15px;
}
.voting-result-item-selected {
  font-weight: bold;
}
.voting-results-item-text {
  padding-bottom: 5px;
  font-size: 18px;
}
.voting-result-bar {
  background-color: gray;
  min-width: 10px;
  border-radius: 4px;
}
.voting-result-bar-background {
  background-color: aliceblue;
  border-radius: 4px;
  height: 12px
}
.voting-result-bar-selected {
  background-color: brown;
  min-width: 10px;
  border-radius: 4px;
}
.voting-results-overall-text {}
.voting-result-item-percent {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/App.vue